import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import Sidebar from './components/Sidebar'
import SanitizeHtml from '../Base/SanitizeHtml/SanitizeHtml'
import ExtrasApp from './components/ExtrasApp'
import constants from '../../../js/lib/constants'
import { setStep } from '../../../js/lib/redux/slices/booking'
import * as lib from '../../../js/lib/lib'
import { postData } from '../../../js/helpers/apiHelper'
import {
  setMilesNBonusAccount,
  setSelectedVehicle,
  resetMBData,
  resetMilesNBonusAccount,
  resetStep3,
} from '../../../js/lib/redux/slices/booking'
import Alert from '../Base/Alert'
import SummaryMobilePanel from './components/SummaryMobilePanel'

const BookingStep2 = () => {
  const { configuration, dictionary, token } = window.bookingData

  const navigateTo = constants.booking.navigateTo
  const pageNumber = constants.booking.pageNumber

  const [showSummary, setShowSummary] = useState(false)
  const { step, selectedVehicle, isPrepaid, selectedExtras } = useSelector(
    (state) => state.booking
  )

  const [isLoading, setIsLoading] = useState(false)
  const [alertMessages, setAlertMessages] = useState([])

  const dispatch = useDispatch()
  const navigate = useNavigate()

  const handleSubmit = (event) => {
    // Prevent default form submission behavior
    if (event) {
      event.preventDefault()
    }
    dispatch(resetStep3())
    lib.scrollToTop()
    dispatch(setStep(pageNumber.payment))
    // navigate(navigateTo.payment)
  }

  const fetchData = async () => {
    try {
      setIsLoading(true)

      const payload = {
        amenities: selectedExtras.map(({ code, quantity }) => ({
          Code: code,
          Quantity: quantity,
        })),
        vehicleGroup: selectedVehicle.car.name,
        rateReference: selectedVehicle.rateReference,
        brandCode: selectedVehicle.brandName,
        acriss: selectedVehicle.car.acriss,
        isPrepaid,
        token: token,
      }

      const response = await postData(
        configuration.endpointGetSingleRate,
        payload
      )

      dispatch(setSelectedVehicle(response.vehicle))
    } catch (err) {
      console.error(err)
      handleError([err])
    } finally {
      handleSuccess()
    }
  }

  const handleSuccess = () => {
    setAlertMessages([])
    setIsLoading(false)
  }

  const handleError = (messages) => {
    setAlertMessages(messages)
    setIsLoading(false)

    setTimeout(() => {
      lib.scrollToError(100)
    }, 0)
  }

  useEffect(() => {
    const handleMBLogin = (event) => {
      const isLoggedIn = event.detail.isLoggedIn
      if (!isLoggedIn) {
        dispatch(resetMilesNBonusAccount())
        dispatch(resetMBData())
      } else {
        dispatch(setMilesNBonusAccount(event.detail.data))
      }
      fetchData()
    }

    window.addEventListener('loggedIn', handleMBLogin)

    return () => {
      window.removeEventListener('loggedIn', handleMBLogin)
    }
  }, [dispatch])

  return (
    <>
      {selectedVehicle && (
        <form onSubmit={handleSubmit}>
          <div className="page-container">
            {alertMessages.length > 0 && <Alert messages={alertMessages} />}

            <div className="row">
              <div className="col-lg-7">
                <div className="s-extras-list">
                  <ExtrasApp
                    extrasEndpoint={configuration.endpointGetSingleRate}
                  />

                  <div className="s-extras-list__terms">
                    <SanitizeHtml
                      html={
                        selectedVehicle?.isGREngine
                          ? dictionary.extrasNoteTextGr
                          : dictionary.extrasNoteText
                      }></SanitizeHtml>
                  </div>
                  <div className="s-extras-list__button">
                    <button
                      type="submit"
                      className="btn btn-primary"
                      title={dictionary.asideProceedLabel}>
                      {dictionary.asideProceedLabel}
                    </button>
                  </div>
                  <SummaryMobilePanel />
                </div>
              </div>
              <div className="col-lg-4 offset-lg-1 d-none d-lg-block">
                <Sidebar />
              </div>
            </div>
          </div>
        </form>
      )}
    </>
  )
}

export default BookingStep2
